import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Title, ContainerControlSite, Container, Theme, Text, Button, Loader, PersonalInfoBlock } from '@simplybenefits/sb-ui-library';
import * as dates from '@simplybenefits/sb-dates';
import { getDependentsAtCoverageEndDate, getUserCoverageHistory } from '../../../../actions/users.js';
import { styled } from '@mui/system';
import Coverage from '../index.js';
import { ArrowBackRounded as ArrowBackIcon } from '@mui/icons-material';

const BlockRowStyled = styled('div')({
    alignItems: 'center',
    backgroundColor: Theme.colors.surface,
    cursor: 'pointer',
    display: 'flex',
    height: 60,
    marginBottom: 5,
    boxShadow: "0 1px 2px rgb(0 0 0 / 15%)",
    borderLeft: `5px solid ${ Theme.colors.surface }`,
    '&:hover': {
        borderLeft: `5px solid ${ Theme.colors.skyBlue }`
    },
    paddingLeft: 30,
    paddingRight: 30,
    flexDirection: "row", 
    justifyContent: "space-between", 
});

const BlockRow = styled('div')({
    alignItems: 'center',
    display: 'flex',
    height: 60,
    borderLeft: `5px solid null`,
    paddingLeft: 35,
    paddingRight: 30,
    flexDirection: "row", 
    justifyContent: "space-between",
    backgroundColor: Theme.colors.skyBlue
});

class CoverageHistory extends Component {
    state = { 
        selectedCoverageHistoryID: null,
        selectedCoverageHistoryRecord: null,
        coverageHistory: {},
        dependentsAtCoverageEndDate: []
    }
            
    _getUserCoverageHistory = (id, dateEnd) => {
        this.setState({
            loading: true
        });
        
        Promise.all([
            this.props.dispatch(getDependentsAtCoverageEndDate(this.props.currentUser.meta.userID, dates.formatOutgoingDate(dateEnd))),
            this.props.dispatch(getUserCoverageHistory(this.props.currentUser.meta.userID, id))
        ]).then((data) => {

            this.setState({
                selectedCoverageHistoryRecord: this.props.currentUser.coverageHistory.find(obj => obj["uid"] === id),
                dependentsAtCoverageEndDate: data[0],
                coverageHistory: data[1],
                selectedCoverageHistoryID: id,
                loading: false
            })

        })
    }

    coverageHistoryRow = (coverageHistory) => {
        return (
            <BlockRowStyled 
                key={ coverageHistory.uid }
                onClick={() => this._getUserCoverageHistory(coverageHistory.uid, coverageHistory.dateEnd) }
            >
                <Text customStyle={{ width: "20%" }}>{ coverageHistory.recordTitle }</Text>

                <Text customStyle={{ width: "30%" }}>{ coverageHistory.uid }</Text>

                <Text customStyle={{ width: "20%" }}>{ coverageHistory.dateChangeWasAdded }</Text>

                <div style={{ display: "flex", flexDirection: "row", width: "18%", justifyContent: "space-evenly" }}>
                    <Text>{ dates.getUTC(coverageHistory.dateStart, "ll") }</Text>
                    <Text>to</Text>
                    <Text>{ dates.getUTC(coverageHistory.dateEnd, "ll") }</Text>
                </div>

            </BlockRowStyled>
        )
    };

    render () {
        const styles = {
            backBtn: {
                marginRight: 1.25, 
                width: "40px", 
                display: "flex", 
                flexDirection: "row"
            },
            recordRow: {
                display: "flex", 
                flexDirection: "row", 
                marginBottom: 20, 
                paddingLeft: 10
            },
            background: {
                flex: 1,
                backgroundColor: '#FFF'
            },
            infoDisplay: {
                display: "flex", 
                flexDirection: "row", 
                marginTop: 20, 
                marginBottom: 20, 
                marginLeft: 40, 
                width: "30%", 
                justifyContent: "space-between"
            },
            infoColumn: {
                display: "flex", 
                flexDirection: "column" 
            }
        }

        if (this.state.loader?.isLoading) {
            return <Loader isContainer/>;
        }
        
        return (
            <ContainerControlSite>
                    {
                        !this.state.selectedCoverageHistoryID ? 

                        <>
                            <Title title="Coverage History Records" />

                            {
                                this.props.currentUser.coverageHistory?.length ?
                                <>
                                    <BlockRow>
                                        <Text bold customStyle={{ width: "20%" }} color="#FFF">Record Name</Text>
                                        <Text bold customStyle={{ width: "30%" }} color="#FFF">Record ID</Text>
                                        <Text bold customStyle={{ width: "20%" }} color="#FFF">Date Added</Text>
                                        <Text bold customStyle={{ width: "18%", paddingLeft: 10 }} color="#FFF">Date Range</Text>
                                    </BlockRow>

                                    {
                                        this.props.currentUser.coverageHistory.map((coverageHistory) => (this.coverageHistoryRow(coverageHistory)))
                                    }
                                    
                                </>
                                 :
                                <Text>There are no coverage history records available to display.</Text>
                            }

                        </>
                        :
                        <Container background={"true"}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                
                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    <Button
                                        customStyle={ styles.backBtn }
                                        onClick={() => this.setState({ selectedCoverageHistoryID: null })}
                                        transparent
                                    >
                                        <ArrowBackIcon sx={{ fontSize: 50 }}/>
                                    </Button>
                                    
                                    <Title title={ `${ this.state.selectedCoverageHistoryRecord.recordTitle }` } />
                                </div>

                            
                                <div style={ styles.recordRow }>
                                    <Text customStyle={{ marginRight: 100 }}>
                                        {"Date Added: "} 
                                        <strong>
                                            { this.state.selectedCoverageHistoryRecord.dateChangeWasAdded }
                                        </strong>
                                    </Text>

                                    <Text customStyle={{ marginRight: 100 }}>
                                        {"Coverage Range: "} 
                                        <strong>
                                            { this.state.selectedCoverageHistoryRecord.dateStart }
                                        </strong>
                                        {" to "} 
                                        <strong>
                                            { this.state.selectedCoverageHistoryRecord.dateEnd }
                                        </strong>
                                    </Text>

                                    <Text>
                                        {"Record ID: "} 
                                        <strong>
                                            { this.state.selectedCoverageHistoryRecord.uid }
                                        </strong>
                                    </Text>
                                </div>

                            </div>

                            <div style={ styles.background }>
                                <PersonalInfoBlock 
                                    meta={ this.state.coverageHistory.meta }
                                    coverage={ this.state.coverageHistory }
                                    classData={ this.props.currentUser.classes }
                                    divisions={ this.props.currentUser.divisions }
                                    disableHeaderRow={true}
                                    disableBorder={true}
                                />

                               { 
                               
                               this.props.currentUser.meta.termDate || this.props.currentUser.meta.reinstateDate ?
                                <div style={{ display: "flex", flexDirection: "row", width: "30%", justifyContent: "space-between", marginLeft: 40 }}>
                                        {
                                            this.props.currentUser.meta.termDate 
                                            && this.props.currentUser.meta.termDate >= dates.getUTC(this.state.selectedCoverageHistoryRecord.dateStart)
                                            && this.props.currentUser.meta.termDate <= dates.getUTC(this.state.selectedCoverageHistoryRecord.dateEnd)
                                            ?
                                            
                                            <div style={ styles.infoColumn }>
                                                <Text avMedium small>Termination Date</Text>
                                                <Text medium light>{ dates.getLocalDisplay(this.props.currentUser.meta.termDate) }</Text>
                                            </div> 

                                            :
                                            null
                                        }

                                        {
                                              this.props.currentUser.meta.reinstateDate 
                                              && this.props.currentUser.meta.reinstateDate >= dates.getUTC(this.state.selectedCoverageHistoryRecord.dateStart)
                                              && this.props.currentUser.meta.reinstateDate <= dates.getUTC(this.state.selectedCoverageHistoryRecord.dateEnd)
                                              ?
                                            
                                            <div style={ styles.infoColumn }>
                                                <Text avMedium small>Reinstate Date</Text>
                                                <Text medium light>{ dates.getLocalDisplay(this.props.currentUser.meta.reinstateDate) }</Text>
                                            </div> 

                                            :
                                            null
                                        }

                                    </div>
                                    :
                                    null
                                }

                                {
                                    this.state.dependentsAtCoverageEndDate.length ? 
                                    <Text medium veryBold customStyle={{ marginTop: 20, marginBottom: 20, marginLeft: 40 }}>Dependent Information</Text>
                                    :
                                    null
                                }

                                {
                                    this.state.dependentsAtCoverageEndDate.map((dependent) => (
                                        <>
                                            <div style={ styles.infoDisplay }>

                                                <div style={ styles.infoColumn }>
                                                    <Text avMedium small>Name</Text>
                                                    <Text medium light>{`${ dependent.firstname } ${ dependent.lastname }`}</Text>
                                                </div> 

                                                <div style={ styles.infoColumn }>
                                                    <Text avMedium small>Relationship</Text>
                                                    <Text medium light>{ dependent.relationship }</Text>
                                                </div>

                                                <div style={ styles.infoColumn }>
                                                    <Text avMedium small >Birthdate</Text>
                                                    <Text medium light>{ dates.getUTC(dependent.birthdate, "ll") }</Text>
                                                </div> 

                                            </div>

                                        </>
                                    ))
                                }

                                {
                                    this.state.dependentsAtCoverageEndDate.map((dependent) => (

                                        dependent.relationship === "Spouse" && dependent.cert ? 

                                        <>
                                            <Text medium veryBold customStyle={{ marginTop: 20, marginBottom: 20, marginLeft: 40 }}>Spouse's Coverage</Text>

                                            <div style={ styles.infoDisplay }>

                                                {
                                                    dependent.employer ?
                                                        <div style={ styles.infoColumn }>
                                                            <Text avMedium small>Organization</Text>
                                                            <Text medium light>{`${ dependent.employer }`}</Text>
                                                        </div> 
                                                        :
                                                        null
                                                }

                                                {
                                                    dependent.insuranceCarrier ?
                                                        <div style={ styles.infoColumn }>
                                                            <Text avMedium small>Insurance Carrier</Text>
                                                            <Text medium light>{ dependent.insuranceCarrier }</Text>
                                                        </div>
                                                        :
                                                        null
                                                }

                                                { 
                                                    dependent.cert ?
                                                        <div style={ styles.infoColumn }>
                                                            <Text avMedium small >Certificate Number</Text>
                                                            <Text medium light>{ dependent.cert }</Text>
                                                        </div>
                                                        :
                                                        null 
                                                }

                                            </div>
                                        </>
                                        :
                                        null

                                        ))
                                }

                                <Text large bold customStyle={{ marginTop: 30, marginLeft: 40 }}>Coverage</Text>
                                
                                <Coverage 
                                    coverage={ this.state.coverageHistory } 
                                    meta={ this.state.coverageHistory.meta }
                                    disableBorder={true}
                                    planDesign={null}
                                />

                            </div>

                        </Container>
                    }

            </ContainerControlSite>
        );
    }
}

export default connect()(CoverageHistory);